import { createContext, useContext, useState, useCallback, useRef } from "react";
import { API } from "../App";
import axios from "axios";

const AvatarContext = createContext(null);

export const useAvatar = () => useContext(AvatarContext);

export const AvatarProvider = ({ children }) => {
  const [avatarState, setAvatarState] = useState(null);
  const [challenge, setChallenge] = useState(null);
  const [level, setLevel] = useState(null);
  const [streakStatus, setStreakStatus] = useState(null);
  const lastRefreshRef = useRef(0);

  const refreshAvatar = useCallback(async (opts = {}) => {
    // Debounce: skip if we refreshed <30s ago, unless force=true.
    const now = Date.now();
    if (!opts.force && now - lastRefreshRef.current < 30000) return;
    lastRefreshRef.current = now;
    try {
      const [stateRes, challengeRes, levelRes, streakRes] = await Promise.all([
        axios.get(`${API}/avatar/state`),
        axios.get(`${API}/avatar/challenge`).catch(() => ({ data: null })),
        axios.get(`${API}/avatar/level`).catch(() => ({ data: null })),
        axios.get(`${API}/avatar/streak/status`).catch(() => ({ data: null })),
      ]);
      setAvatarState(stateRes.data);
      if (challengeRes.data) setChallenge(challengeRes.data);
      if (levelRes.data) setLevel(levelRes.data);
      if (streakRes.data) setStreakStatus(streakRes.data);
    } catch (err) {
      console.debug("[Avatar] refresh failed:", err.message);
    }
  }, []);

  return (
    <AvatarContext.Provider value={{ avatarState, challenge, setChallenge, level, streakStatus, setStreakStatus, refreshAvatar }}>
      {children}
    </AvatarContext.Provider>
  );
};
